import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box } from '@mui/material';

interface Props {
    name: string;
    isPrivate?: boolean;
}

/** A firm's name, with a lock for private firms, whose client data needs the firm's permission */
export default function LawFirmName({ name, isPrivate }: Props) {
    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
            {name}
            {isPrivate && (
                <LockOutlinedIcon
                    titleAccess="Private firm"
                    sx={{ fontSize: 16, color: 'neutral.N_500' }}
                />
            )}
        </Box>
    );
}
